type StepDefinition = {
    from: number;
    to: number;
    step: number;
};

// Кастомный конфиг для диапазона 0 - 300000000
export const fullPriceStepConfig: StepDefinition[] = [
    // Для небольших значений — шаг 10 000 от 0 до 100 000
    { from: 0, to: 100_000, step: 10_000 },
    // От 100 000 до 1 000 000 — шаг 50 000
    { from: 100_000, to: 1_000_000, step: 50_000 },
    // От 1 000 000 до 10 000 000 — шаг 500 000
    { from: 1_000_000, to: 10_000_000, step: 500_000 },
    // От 10 000 000 до 50 000 000 — шаг 2 000 000
    { from: 10_000_000, to: 50_000_000, step: 2_000_000 },
    // От 50 000 000 до 300 000 000 — шаг 5 000 000
    { from: 50_000_000, to: 300_000_000, step: 5_000_000 },
];

export const areaWorthStepConfig = [
  { from: 0, to: 10000, step: 1000 },
  { from: 10000, to: 100000, step: 5000 },
  { from: 100000, to: 1000000, step: 10000 },
];

export const monthlyPaymentStepConfig = [
    { from: 0, to: 500_000, step: 5_000 },
    // От 500 000 до 2 000 000: шаг 25 000 для плавного перехода
    { from: 500_000, to: 2_000_000, step: 25_000 },
    // От 2 000 000 до 10 000 000: шаг 100 000
    { from: 2_000_000, to: 10_000_000, step: 100_000 },
    // От 10 000 000 до 25 000 000: шаг 250 000 для быстрого охвата верхнего диапазона
    { from: 10_000_000, to: 25_000_000, step: 250_000 },
];

// Глобальные диапазоны для фильтров, собранные в один объект
export const FILTER_LIMITS = {
  fullPrice: { min: 0, max: 300_000_000 },
  requiredPayment: { min: 0, max: 300_000_000 },
  areaWorth: { min: 0, max: 1_000_000 },
  monthlyPayment: { min: 0, max: 25_000_000 },
};
